import { encoder } from 'node-esapi';
import { sanitizeUrl } from '@braintree/sanitize-url';
import { sanitizeString } from './sanitizeString';
import Logger from './logger';

/*
* This function escapes '&' and '=' characters within an object in the hash query
*/
export const escapeObjectInHashQuery = (hashQuery) => {
  try {
    if (hashQuery) {
      // Extract the object inside curly braces
      const objectMatch = hashQuery.match(/{.*}/);
      if (objectMatch) {
        const esapiEncoder = encoder();
        const hashObject = objectMatch[0]; // The matched object string
        const encodedObject = esapiEncoder.encodeForURL(decodeURIComponent(hashObject));

        // Replace the original object with the encoded one
        return hashQuery.replace(/{.*}/, encodedObject);
      }
    }
    return hashQuery;
  } catch (error) {
    Logger.error(`ERROR encoding the hash query: ${hashQuery}`, error);
    return hashQuery;
  }
};

export const encodeSearchParams = (searchParams) => {
  const esapiEncoder = encoder();
  const encodedSearchParams = [];
  new URLSearchParams(searchParams).forEach((value, key) => {
    encodedSearchParams.push(`${esapiEncoder.encodeForURL(key)}=${esapiEncoder.encodeForURL(value)}`);
  });
  return encodedSearchParams.join('&');
};

export const encodePathname = (pathname) => {
  const esapiEncoder = encoder();
  return decodeURIComponent(pathname)
    .split('/')
    .map((segment) => esapiEncoder.encodeForURL(segment))
    .join('/');
};

export const encodeURL = (url) => {
  // If URL is not absolute URL, return the URL as is
  if (!(url.includes('://') || url.startsWith('//'))) return url;
  try {
    const urlObject = new URL(url);

    // Encode pathname
    urlObject.pathname = encodePathname(urlObject.pathname);

    // Encode search params
    urlObject.search = encodeSearchParams(urlObject.search);

    // Encode hash with hash search Params
    if (urlObject.hash) {
      const [hashPath, hashQuery] = urlObject.hash.split('?');
      const encodedHashPath = encodePathname(hashPath.split('#')[1]);
      const encodedHashQuery = encodeSearchParams(escapeObjectInHashQuery(hashQuery));
      urlObject.hash = `#${encodedHashPath}${encodedHashQuery ? `?${encodedHashQuery}` : ''}`;
    }

    return urlObject.toString();
  } catch (error) {
    Logger.error(`Error encoding the ${url}`, error);
  }
  return url;
};

export const sanitizeTargetUrl = (url) => {
  try {
    const escapeHTML = sanitizeString(url);

    // implements braintree's sanitizer, checks for invalid protocols like in scripts like javascript/data
    return encodeURL(sanitizeUrl(escapeHTML));
  } catch (e) {
    Logger.error(`ERROR in URL Sanitizer for ${url}`);
    return 'about:blank';
  }
};

export const redirectToSanitizedUrl = (url, openInNewTab = false) => {
  const sanitizeUrlToRedirect = sanitizeTargetUrl(url);
  if (openInNewTab) {
    window.open(sanitizeUrlToRedirect);
  } else {
    window.location.href = sanitizeUrlToRedirect;
  }
};
